"use client";

import Arrow2DownIcon from "@/app/_components/Icons/Arrow2DownIcon";
import Arrow2LeftIcon from "@/app/_components/Icons/Arrow2LeftIcon";
import { Box, Card, CardActionArea, CardContent, Collapse, Icon, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { toggleBrandId } from "../brandFilterSchema";
import SearchFiltersBrandsSelect from "../SearchFiltersBrandsSelect";
import { useSiteSearchContext } from "../SiteSearchContext";

export default function BrandsSideFilter({ intiOpen }: { intiOpen?: boolean }) {
  const { brands, selectedBrands, handleBrandsChange } = useSiteSearchContext();
  const [open, setOpen] = useState(intiOpen ?? Boolean(selectedBrands && selectedBrands.length > 0));

  if (!brands || brands.length === 0) {
    return null;
  }

  return (
    <Box sx={{ borderRadius: 2 }}>
      <Card elevation={0} sx={{ borderRadius: 0 }}>
        <CardActionArea
          onClick={() => {
            setOpen(!open);
          }}
          sx={{
            p: {
              md: 2,
              xs: 1,
            },
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="subtitle1">
              برندها
              {selectedBrands && selectedBrands.length > 0 ? ` (${selectedBrands.length})` : ""}
            </Typography>
            <Icon color="secondary" fontSize="small">
              {!open ? <Arrow2LeftIcon /> : <Arrow2DownIcon />}
            </Icon>
          </Stack>
        </CardActionArea>
        <Collapse in={open}>
          <CardContent>
            <SearchFiltersBrandsSelect
              brands={brands}
              values={selectedBrands}
              onToggle={(id) => {
                handleBrandsChange(toggleBrandId(selectedBrands, id), false);
              }}
            />
          </CardContent>
        </Collapse>
      </Card>
    </Box>
  );
}
